/**
 * WhatsApp facade: keep the visible button, load full CSS/JS after first
 * interaction + short delay. First button click is captured and replayed.
 */
(() => {
  const root = document.getElementById("whatsapp-chat");
  if (!root) return;
  if (customElements.get("whatsapp-chat")) {
    root.classList.remove("whatsapp-chat--facade");
    return;
  }

  const loader = window.BoltFeatureLoader;
  const assets = window.BoltAssets || {};
  const btn = root.querySelector("#whatsapp-chat-btn");
  const cssHref = assets.whatsappChatCss || root.dataset.facadeCss;
  const jsSrc = assets.whatsappChat || root.dataset.facadeJs;
  if (!loader || !btn || !jsSrc) return;

  const DELAY_MS = 2000;
  let hydratePromise = null;

  const hydrate = () => {
    if (customElements.get("whatsapp-chat")) return Promise.resolve();
    if (hydratePromise) return hydratePromise;

    hydratePromise = Promise.all([
      cssHref ? loader.loadStylesheet(cssHref, "bolt-whatsapp-css") : Promise.resolve(),
      loader.loadScript(jsSrc, "bolt-whatsapp-js"),
    ])
      .then(() => customElements.whenDefined("whatsapp-chat"))
      .then(() => {
        root.classList.add("show");
        root.classList.remove("whatsapp-chat--facade");
        root.dataset.facadeBound = "true";
        btn.removeEventListener("click", onFirstClick, true);
      })
      .catch((error) => {
        hydratePromise = null;
        root.dataset.facadeBound = "false";
        console.error("WhatsApp facade failed to load", error);
        throw error;
      });

    return hydratePromise;
  };

  const onFirstClick = async (event) => {
    if (customElements.get("whatsapp-chat")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    btn.classList.add("loading");

    try {
      await hydrate();
      btn.classList.remove("loading");
      btn.click();
    } catch (error) {
      btn.classList.remove("loading");
    }
  };

  btn.addEventListener("click", onFirstClick, true);
  loader.onFirstInteraction(() => {
    setTimeout(() => {
      hydrate();
    }, DELAY_MS);
  });
})();
